<script setup>
defineProps({
  open: Boolean,
});

defineEmits(["close"]);
</script>

<template>
  <div v-if="open" class="contact-modal-backdrop" @click.self="$emit('close')">
    <div class="contact-modal-content">
      <button class="contact-modal-close" @click="$emit('close')">×</button>

      <h2>MINDONE Support</h2>

      <p class="d-flex align-items-center">
        <i class="material-icons me-2">email</i>
        <a href="mailto:office@mind-one.com">office@mind-one.com</a>
      </p>
      <p class="d-flex align-items-center">
        <i class="material-icons me-2">phone</i>
        <a href="tel:+43153308550">+43 1 533 08 55 0</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.contact-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.contact-modal-content {
  background: white;
  border-radius: 8px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease-out;
  z-index: 1000000;
  display: block !important;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.contact-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.contact-modal-close:hover {
  background-color: #f0f0f0;
  color: #333;
}

h2 {
  margin: 0 0 24px 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

p {
  margin: 16px 0;
  font-size: 16px;
  color: #555;
}

a {
  color: #1976d2;
  text-decoration: none;
  transition: color 0.2s;
}

a:hover {
  color: #1565c0;
  text-decoration: underline;
}
</style>
